import { useCallback, useEffect, useRef, useState } from 'react'

export const useAudioFile = (url?: string) => {
  const [isPlaying, setIsPlaying] = useState(false)
  const audioRef = useRef(url ? new Audio(url) : null)
  const [currentTime, setCurrentTime] = useState(0)

  const handlePlay = () => {
    if (audioRef.current) {
      setIsPlaying(true)
      audioRef.current.play()
    }
  }

  const handlePause = useCallback(() => {
    if (audioRef.current) {
      setIsPlaying(false)
      audioRef.current.pause()
    }
  }, [])

  useEffect(
    () => {
      if (url) {
        const cleanup = () => {
          if (audioRef.current) {
            handlePause()
          }
        }

        if (audioRef.current) {
          cleanup()
        }

        audioRef.current = new Audio(url)

        audioRef.current.addEventListener('ended', () => {
          setIsPlaying(false)
        })

        audioRef.current.addEventListener('timeupdate', function () {
          // eslint-disable-next-line no-invalid-this
          setCurrentTime(this.currentTime)
        })

        return cleanup
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [url],
  )

  const setAudio = useCallback((audioUrl: string) => {
    audioRef.current = new Audio(audioUrl)
  }, [])

  return { handlePlay, handlePause, isPlaying, currentTime, setAudio }
}
